import { TranslateFunc } from 'ha/i18n';

export enum DefaultTextType {
  Update = 'Update',
  ShowResults = 'Show Results',
}

export default (
  T: TranslateFunc,
  defaultText: DefaultTextType,
  numberOfListings?: number,
) => {
  const defaultTextTranslation =
    defaultText === DefaultTextType.Update ? T('Update') : T('Show results');

  return numberOfListings
    ? T('Show %(number)d results', { number: numberOfListings })
    : defaultTextTranslation;
};
